<template>

<form @submit.prevent="submitDish">
        <div class="form-group mb-3">
            <label for="name">Name of Dish</label>
            <input type="text" v-model="item.name" class="form-control" id="name"
                placeholder="Authentic Bengali food">
        </div>

        <div class="form-group mb-3">
            <label for="description">Description</label>
            <textarea v-model="item.description" class="form-control" id="description" rows="5"></textarea>
        </div>
        
        <div class="d-flex justify-content-center">
            <button type="submit" class="btn btn-dark">Submit</button>
        </div>
    </form>
    
</template>

<script setup>
import api from "@/services/api";
import { useKitchenStore } from "@/stores/kitchen";
import { defineProps, computed } from "vue";


const props = defineProps(['dish', 'closeModal']);

const store = useKitchenStore();

const item = computed(() => {
    return { ...props.dish };
});



async function submitDish(){
      const result =  await api.post('/user/admin/dish/', item.value);
      store.addDishToKitchen(result.data);
      props.closeModal(false);
}

</script>